// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__HZ6Fg","content":"header_content__3O2Zn","title":"header_title__3EkoF","button":"header_button__15RN2","icon":"header_icon__1EhbJ"};